import { Injectable } from "@angular/core";
import { GeneralService } from "./general.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Page } from "../model/page";
import { Observable } from "rxjs/Observable";
import * as _ from "lodash";
import { saveAs } from "@progress/kendo-file-saver";
import { ToastrService } from "ngx-toastr";

@Injectable()
export class FileExportsService extends GeneralService {
  static STATUS_REQUESTED = 10;
  static STATUS_PROCESSING = 20;
  static STATUS_READY = 30;
  static STATUS_FAILED = 40;

  static TYPE_MASTER_DATA = 10;
  static TYPE_PART_USAGE_BY_DATE = 20;
  static TYPE_OES_USAGE_STATS = 30;
  static TYPE_OES_SCANNED_DATA = 40;
  static TYPE_OES_USAGE_MONTHLY_STATS = 50;
  static TYPE_TEAMWORK_REPORTS = 60;

  constructor(protected http: HttpClient, private toast: ToastrService) {
    super(http);
  }

  public getStatusOptions() {
    return [
      { value: FileExportsService.STATUS_REQUESTED, label: "Requested" },
      { value: FileExportsService.STATUS_PROCESSING, label: "Processing" },
      { value: FileExportsService.STATUS_READY, label: "Ready" },
      { value: FileExportsService.STATUS_FAILED, label: "Failed" },
    ];
  }

  public getTypeOptions() {
    return [
      {
        value: FileExportsService.TYPE_MASTER_DATA,
        label: "Master Data (OES)",
      },
      {
        value: FileExportsService.TYPE_PART_USAGE_BY_DATE,
        label: "Part Usage by Date (OES)",
      },
      {
        value: FileExportsService.TYPE_OES_USAGE_STATS,
        label: "Usage Analysis (OES)",
      },
      {
        value: FileExportsService.TYPE_OES_SCANNED_DATA,
        label: "Scanned Data (OES)",
      },
      {
        value: FileExportsService.TYPE_OES_USAGE_MONTHLY_STATS,
        label: "Usage Analysis Monthly (OES)",
      },
        {
           value: FileExportsService.TYPE_TEAMWORK_REPORTS,
            label: "Teamwork Report",
        },
    ];
  }

  public getItems(page: Page): Observable<any> {
    let params = new HttpParams();
    params = params.append("perPage", page.size.toString());
    params = params.append("page", page.pageNumber.toString());
    if (!_.isUndefined(page.sortParams)) {
      for (const key of Object.keys(page.sortParams)) {
        const value = page.sortParams[key];
        params = params.append("sort[]", key + "," + value);
      }
    }
    if (!_.isUndefined(page.filterParams)) {
      for (const key of Object.keys(page.filterParams)) {
        const value = page.filterParams[key];
        if (value && value !== "") {
          params = params.append(key, value);
        }
      }
    }
    return this.http.get(this.apiUrl + "/file-export", { params: params });
  }

  public downloadFile(FE1_ID: number, FE1_FILENAME: string) {
    const url = `${this.apiUrl}/file-export/download-file`;
    this.http
      .get(url, {
        params: { FE1_ID: FE1_ID.toString() },
        responseType: "blob",
        observe: "response",
      })
      .subscribe(
        (result) => {
          const headers = result.headers;
          const disposition = headers.get("Content-Disposition");
          const fileName = FE1_FILENAME;
          const blob = new Blob([result.body]);
          saveAs(blob, fileName);
        },
        () => {
          this.toast.error("Failed to download the file.", "Error");
        }
      );
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/file-exports.service.ts